import Vue from 'vue'
import VueGtm from 'vue-gtm'
import { mapGetters } from 'vuex'
import router from '@/router'

export default {
  computed: {
    ...mapGetters({
      portalConfigurations: 'tenantDesign/config'
    })
  },
  methods: {
    initGoogleTagManager () {
      if (!this.portalConfigurations.integrations) {
        return
      }

      if (!this.portalConfigurations.integrations.portalGoogleTagManagerId) {
        return
      }

      let tagManagerId = this.portalConfigurations.integrations.portalGoogleTagManagerId

      if (!tagManagerId) {
        return
      }

      const isProd = process.env.NODE_ENV === 'production'

      Vue.use(VueGtm, {
        id: tagManagerId,
        debug: !isProd,
        vueRouter: router
      })
    }
  }
}
